import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../lib/queryClient';

// Note: React Query cache is intentionally NOT persisted to localStorage.
// Persisting would leave sensitive API response data in durable browser storage,
// widening the XSS exfiltration surface. All data is fetched fresh per session.

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
